import { getAccessToken, parseAccessTokenClaims } from '@beatq/shared';

/** Seed ULIDs from prisma/seeds/reference-data.ts — fixtures/tests only, never a live JWT fallback. */
export const DEV_BUSINESS_ID = '01JDEVBUSINESS000000000001';
export const DEV_BRANCH_ID = '01JDEVBRANCH0000000000001';

const BRANCH_ID_STORAGE_KEY = 'beatq.merchant.branchId';

export function getApiBaseUrl(): string {
  if (typeof import.meta !== 'undefined') {
    const env = (import.meta as { env?: { VITE_API_BASE_URL?: string } }).env;
    if (env?.VITE_API_BASE_URL) return env.VITE_API_BASE_URL;
  }
  return '';
}

function storedBranchId(): string {
  if (typeof localStorage === 'undefined') return '';
  try {
    return localStorage.getItem(BRANCH_ID_STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
}

export function currentMerchantScope(): { businessId: string; branchId: string } {
  const claims = parseAccessTokenClaims(getAccessToken());
  return {
    businessId: claims.biz ?? '',
    branchId: claims.brn || storedBranchId(),
  };
}

export function merchantScopeHeaders(): Record<string, string> {
  const { branchId } = currentMerchantScope();
  return branchId ? { 'x-scope-id': branchId } : {};
}
